import dayjs, { Dayjs } from "dayjs"
import tz from "dayjs/plugin/timezone"

// Add timezone support, so everyone gets Sydney time
// TODO: Support TFF?
dayjs.extend(tz)
dayjs.tz.setDefault("Australia/Sydney")

// Reference:
// https://day.js.org/docs/en/display/format

type DateLike = string | Date | Dayjs

const today = dayjs().startOf("day")
export function formatDateTime(date: DateLike) {
  const day = dayjs(date)
  const diff = day.diff(today, "days")
  const excludeYear = diff > -30 && diff < 90
  let formatted = day.format("ddd, D MMM YYYY h:mma").replace(/:00/, "")
  if (excludeYear) {
    formatted = formatted.replace(/ \d{4}/, "")
  }
  return formatted
}

export function formatUpcomingTime(date: string) {
  const day = dayjs(date)
  let formattedDate = ""
  const diff = day.diff(today, "days")
  if (diff === 0) {
    formattedDate = "Today"
  } else if (diff === 1) {
    formattedDate = "Tomorrow"
  } else if (diff < 7) {
    formattedDate = day.format("dddd")
  } else {
    formattedDate = day.format("D MMM")
  }
  let formattedTime = day.format("h:mma").replace(/:00/, "")
  return formattedDate + ", " + formattedTime
}

export function formatLongDateTime(date: DateLike) {
  const day = dayjs(date)
  const diff = day.diff(today, "days")
  const excludeYear = diff > -30 && diff < 90
  let formatted = day.format("ddd, D MMMM YYYY h:mma").replace(/:00/, "")
  if (excludeYear) {
    formatted = formatted.replace(/ \d{4}/, "")
  }
  return formatted
}

export function formatStaticDateTime(date: DateLike) {
  const day = dayjs(date)
  let formatted = day.format("ddd, D MMMM YYYY h:mma").replace(/:00/, "")
  return formatted
}

export function formatNiceDate(date: DateLike) {
  return dayjs(date).format("ddd D MMMM YYYY")
}

export function formatBasicDate(date: DateLike) {
  return dayjs(date).format("D/MM/YYYY")
}

export function formatNiceTime(date: DateLike) {
  return dayjs(date).format("h:mma").replace(/:00/, "")
}

export function formatSimpleTime(date: DateLike) {
  return dayjs(date).format("h:mma")
}

export function formatEndTime(date: DateLike, runtimeMinutes: number) {
  if (!runtimeMinutes) return ""
  const day = dayjs(date)
  return day.add(runtimeMinutes, "minutes").format("h:mma")
}

export function formatDateUri(date: DateLike) {
  return dayjs(date).format("YYYY-MM-DD")
}

export function formatTimeUri(date: DateLike) {
  return dayjs(date).format("HH:mm")
}

export function formatDateIso(date: DateLike) {
  return dayjs(date).format("YYYY-MM-DDTHH:mm:ssZ")
}

export function isPastDate(date: DateLike) {
  return dayjs(date).isBefore(dayjs())
}

export function formatFerveDate(date: DateLike) {
  return dayjs(date).format("YYYY-MM-DDTHH:mm:ss")
}
